import { useId } from "react";
import BookingDialog from "./BookingDialog";
import type { ReactNode } from "react";

interface Props {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  danger?: boolean;
}

export default function ConfirmDialog({ title, children, confirmLabel, cancelLabel, onConfirm, onCancel, busy, danger }: Props) {
  const titleId = useId();
  return (
    <BookingDialog titleId={titleId} onClose={onCancel} busy={busy} className="max-w-sm" layer={70}>
      <div className="min-h-0 overflow-y-auto p-5 sm:p-6">
        <h2 id={titleId} className="mb-2 text-lg font-semibold text-sea-900">{title}</h2>
        <div className="mb-5 text-sm leading-relaxed text-primary-700 [overflow-wrap:anywhere]">{children}</div>
        <div className="flex flex-col gap-2 sm:flex-row-reverse">
          <button type="button" className={danger ? "btn-danger w-full min-h-11" : "btn-primary w-full min-h-11"} onClick={onConfirm} disabled={busy}>{confirmLabel}</button>
          <button type="button" data-autofocus className="btn-secondary w-full min-h-11" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
        </div>
      </div>
    </BookingDialog>
  );
}
